import React from 'react';
import cx from 'clsx';
import * as themeStyles from '../../assets/theme.module.scss';

const Toast = ({ msg, onClose }) => (
    <div aria-live="polite" aria-atomic="true" style={{ position: 'relative', minHeight: '200px', zIndex: 10000 }}>
        <div
            className={themeStyles.toast}
            style={{
                position: 'fixed', top: '10px', right: '10px', opacity: 1,
            }}
        >
            <div className={themeStyles.toastHeader}>
                <strong className={themeStyles.mrAuto}>建臺有限公司</strong>
                <button type="button" className={cx(themeStyles.ml2, themeStyles.mb1, themeStyles.close)} data-dismiss="toast" aria-label="Close" onClick={onClose}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className={themeStyles.toastBody}>
                {msg}
            </div>
        </div>
    </div>
);

export default Toast;
